import plur from "plur";
import { PaymentMethod } from "../../../../common/enums";

const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.ACH]: "ACH direct deposit",
  [PaymentMethod.Wire]: "Wire transfer",
  [PaymentMethod.Check]: "Check",
};

export const getPaymentMethodText = (paymentMethod: PaymentMethod): string => {
  return PAYMENT_METHOD_LABELS[paymentMethod];
};

export const getToastSuccessMessage = ({
  positionsCount,
  accountsCount,
  paymentMethod,
}: {
  positionsCount: number;
  accountsCount: number;
  paymentMethod?: PaymentMethod;
}): string => {
  const paymentPrefLabel = paymentMethod ? getPaymentMethodText(paymentMethod) : "The";
  const plurInvestment = plur("investment", positionsCount);
  const plurAccount = plur("account", accountsCount);
  return `${paymentPrefLabel} payment method applied to ${positionsCount} ${plurInvestment} in ${accountsCount} investment ${plurAccount}.`;
};

export const getSummaryDescription = ({
  positionsCount,
  accountsCount,
}: {
  positionsCount: number;
  accountsCount: number;
}): string => {
  return `This payment method was applied to ${positionsCount} ${plur(
    "investment",
    positionsCount,
  )} in ${accountsCount} investment ${plur("account", accountsCount)}`;
};
